define(function (require, exports, module) {
    'use strict';

    const app = require('Cloud/Application/app');
    const MicroEvent = require('mrg-microevent');
    const uploadLog = require('./Upload/uploadLog');
    const UploadController = require('./Upload/UploadController');
    const DropArea = require('./Upload/tools/dnd/DropArea');
    const $ = require('jquery');

    function initAndImplementOldInterface() {
        var uploadController = new UploadController();

        app.upload = {
            _controller: uploadController,
            _log: uploadLog,

            cancelLoadFile: function (id) {
                uploadController._onCancel({}, { id });
            },

            onInputChange: function (event, descriptorOptions = {}) {
                uploadController.onInputChange(event, descriptorOptions);
            },

            onDrop: function (data, descriptorOptions = {}) {
                uploadController.onDrop(data, descriptorOptions);
            },

            allCancelLoadFile: function () {
                uploadController._onCancelAll();
            },

            closeOldUploader: function () {
                uploadController._onClose();
            },

            isActive: function () {
                return uploadController.isActive();
            },

            isDragAndDropable: function () {
                return DropArea.isSupported();
            },

            disableDropArea: function () {
                const dropArea = uploadController.dropArea();

                if (dropArea) {
                    dropArea.disableDropArea();
                }
            },

            enableDropArea: function () {
                const dropArea = uploadController.dropArea();

                if (dropArea) {
                    dropArea.enableDropArea();
                }
            },

            clearUploadedQueue: function () {
                uploadController.clearUploadedQueue();
            },

            setInputs: function ($inputs) {
                $($inputs).on('change', function (event) {
                    uploadController.handleEvent(event);
                });
            },
        };

        MicroEvent.mixin(app.upload);

        window.addEventListener('beforeunload', function (event) {
            if (uploadController.isActive()) {
                var lang = app.getLang();
                var message = lang.upload.beforeunload;

                event.returnValue = message;

                return message;
            }
        });
    }

    module.exports = initAndImplementOldInterface;
});
